import { useClosetItemInShortReview, useClosetItemsToShortReview } from "@hooks/use-review-short";
import ProductImage from "@components/core/ProductImage";
import classNames from "classnames";

function ClosetItemsToReview() {
  const closetItemsToReview = useClosetItemsToShortReview();
  const closetItemInReview = useClosetItemInShortReview();

  return (
    <div className="p-3 d-flex gap-2 justify-content-center dark-background">
      {closetItemsToReview?.map((closetItem) => (
        <div
          key={closetItem.id}
          className={classNames(
            "closet-item-to-review",
            closetItem.id !== closetItemInReview?.id && "not-in-review",
          )}
        >
          <ProductImage
            src={closetItem.product.main_picture_url}
            alt={closetItem.product.name}
            className="w-100"
            sizes="128px"
          />
        </div>
      ))}
    </div>
  );
}

export default ClosetItemsToReview;
